import { LOCALE_META, type Locale } from "./locale";

/**
 * The prerendered, crawlable pages under `dist/` (see scripts/seo-pages.mjs).
 * Only these exist in more than one language; everything else is English-only,
 * and linking a French page at an English one is better than linking it at a
 * French URL that 404s. Keep in sync with `TRANSLATED` in seo-pages.mjs.
 */
const TRANSLATED = new Set(["about/", "shapes/", "best-drawing-apps-for-kids/"]);

/** Absolute path to a static page in `locale`, falling back to English. */
export function staticPath(page: string, locale: Locale): string {
  if (locale === "en" || !TRANSLATED.has(page)) return `/${page}`;
  return `/${LOCALE_META[locale].htmlLang}/${page}`;
}
